module.exports = __webpack_public_path__ + "img/Lao People's Democratic Republic.b22bd158.svg";